<template>
  <div class="uploading-file-item">
    <file-item :file="customFile">
      <span>{{ status }}</span>
    </file-item>
    <div class="file-upload-progress" :style="style" />
  </div>
</template>

<style lang="scss">
.uploading-file-item {
  position: relative;
  z-index: 1;

  .file-upload-progress {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background-color: #dcf3dd;
    z-index: -1;
    transition: width .5s;
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { RemoteFile } from '../../type';
import { upload } from '.';
import FileItem from '../FileItem.vue';

interface Data {
  progress: number,
}

export default defineComponent({
  emits: ['uploaded'],
  components: {
    FileItem,
  },
  props: {
    file: {
      type: Object as () => File,
      required: true,
    },
  },
  data(): Data {
    return {
      progress: 0,
    };
  },
  computed: {
    customFile(): RemoteFile {
      return {
        name: this.file.name,
        url: URL.createObjectURL(this.file),
      };
    },
    style(): object {
      return {
        width: `${this.progress}%`,
      };
    },
    status(): string {
      return (this.progress < 100) ? 'Uploading...' : 'Saving...';
    },
  },
  methods: {
    upload() {
      const setProgress = (progress: number) => {
        this.progress = progress;
      };
      const task = upload(this.file, { onProgress: setProgress });
      task.then((uploadedFile) => {
        this.$emit('uploaded', uploadedFile);
      });
    },
  },
  created() {
    this.upload();
  },
});
</script>
